<template>
    <transition name="slide-fade">
        <div class="notification-bar" @click="closeModal(false)">
            <div class="container">
                <div class="row">
                    <div class="col offset-md-2 offset-lg-1 col-md-8 col-lg-10 col-sm-12 text-center">
                        <div class="notification-bar__notification">
                            <span v-html="message"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </transition>
</template>

<script lang="ts">
    import Vue from "vue";
    import { gsap } from "gsap";


    export default Vue.component('notification-bar', {
        data: function () {
            return {
                mounted: false
            }
        },
        mounted: function () {
            this.mounted = true;
            if (this.time && this.time > 0) {
                setTimeout(
                    () => { this.closeModal() }, this.time);
            }

        },
        created() {

        },
        props: {
            message: {
                default: '',
                type: String,
            },
            time: {
                default: 0,
                type: Number,
                required: true,
            }
        },
        methods: {
            closeModal() {
                this.$emit('closeModal');
            },
            btnCloseModal() {
                this.$emit('btnCloseModal');
            },
            onBeforeEnter(el) {
                el.style.opacity = 0;
                gsap.to(el, {
                    scale: 0.9,
                    duration: 0,
                    alpha: 0,
                    translateY: 500
                })
            },
            onEnter(el, done) {
                gsap.to(el, {
                    scale: 1,
                    alpha: 1,
                    duration: .5,
                    x: 0,
                    translateY: 0,
                    onComplete: done,
                    delay: el.dataset.index * 0.05
                })
            },
        }
    });
</script>